import Form from '../components/Form';
import Title from '../components/Title';
import {FormattedMessage} from 'react-intl';
import Messages from './Sidebar.messages';

export default ({advertiser, category, ...props}) => {
    return <div>
        <h4 className="h6 text-pink mb-2">
            <FormattedMessage {...Messages.title}/>
        </h4>
        <p className="small mb-3">
            <Title advertiser={advertiser} category={category}/>
        </p>
        <Form advertiser={advertiser} category={category} {...props} />
    </div>
}
